module.exports = __webpack_public_path__ + "static/audioedit-bd6736ac712e93e7847dff130ea2fc52.png";